import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var requestSchema = yup.object({
  appointmentId: yup.number().required(),
  isConfirmed: yup.boolean().required(),
});

export function useConfirmAppointmentMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      var req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return await http.post(HTTP_ENDPOINTS.appointments.confirm(), {
        appointment_id: req.appointmentId,
        is_confirmed: req.isConfirmed,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.appointments.appointment],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
